import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { BookingMultiDayComponent } from './booking-multi-day.component'

const routes: Routes = [
  {
    path: '',
    component: BookingMultiDayComponent,
    pathMatch: 'full'
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BookingMultiDayRoutingModule {}
